import React from "react";
import { ArrowRight, ChevronDown, BadgeCheck } from "lucide-react";
import Reveal from "./Reveal";
import logo from "../assets/logo.png";

export function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "linear-gradient(160deg,#0B0E13 0%,#12161F 55%,#180C0C 100%)" }}
    >
      <div
        className="blob1 absolute rounded-full"
        style={{ width: 420, height: 420, background: "radial-gradient(circle,rgba(225,58,48,0.28),transparent 70%)", top: -80, right: -100 }}
      ></div>
      <div
        className="blob2 absolute rounded-full"
        style={{ width: 360, height: 360, background: "radial-gradient(circle,rgba(225,58,48,0.16),transparent 70%)", bottom: -60, left: -80 }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20 grid md:grid-cols-2 gap-12 items-center w-full">
        <div>
          <Reveal>
            <p className="uppercase tracking-widest text-xs mb-6" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
              The Curated Edit — SS26
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="text-white leading-tight" style={{ fontFamily: "Fraunces, serif", fontSize: "clamp(2.5rem,6vw,4.5rem)" }}>
              Big Brands.
              <br />
              <em style={{ color: "#1E9AFF", fontStyle: "italic" }}>One Address.</em>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-base md:text-lg" style={{ color: "rgba(245,241,234,0.6)" }}>
              120+ handpicked labels, authenticated and delivered to your door — because good taste shouldn't mean twelve different tabs.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="flex flex-wrap gap-4 mt-10">
              <a href="#shop" className="btn-primary px-7 py-3 rounded-full text-sm tracking-widest uppercase inline-flex items-center gap-2">
                Shop New Arrivals <ArrowRight size={16} />
              </a>
              <a
                href="#categories"
                className="px-7 py-3 rounded-full text-sm tracking-widest uppercase inline-flex items-center gap-2 text-white transition-colors"
                style={{ border: "1px solid rgba(255,255,255,0.2)" }}
              >
                Explore Collections
              </a>
            </div>
          </Reveal>
        </div>

        <div className="relative hidden md:flex justify-center">
          <div
            className="float-tag rounded-2xl p-8 w-72"
            style={{ background: "#12161F", border: "1px solid rgba(225,58,48,0.25)", boxShadow: "0 30px 60px rgba(0,0,0,0.5)" }}
          >
            <img src={logo} alt="Marque" style={{ height: 90, width: "auto", margin: "0 auto 20px" }} />
            <p className="text-xs uppercase tracking-widest mb-2" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
              Authenticity Card
            </p>
            <h4 style={{ fontFamily: "Fraunces, serif" }} className="text-2xl mb-4 text-white">SS26 Edit</h4>
            <div className="flex items-center justify-between text-xs uppercase tracking-widest text-white opacity-50" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
              <span>No. 0001</span>
              <span style={{ color: "#1E9AFF", opacity: 1, display: "inline-flex", alignItems: "center", gap: 4 }}>
                Verified <BadgeCheck size={13} />
              </span>
            </div>
          </div>
        </div>
      </div>

      <a href="#marquee" className="scroll-cue absolute bottom-8 left-1/2 text-white opacity-50" aria-label="Scroll down">
        <ChevronDown />
      </a>
    </section>
  );
}

export default Hero;
